import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCase'
})
export class CamelCasePipe implements PipeTransform {

  transform(values: any, ...args: any[]): any {
    let result = '';

    for (let value of values) {
      result += this.capitalize(value) + ',';
    }

    if (result.endsWith(',', result.length)) {
      result = result.substring(0, result.length - 1);
    }
    return result;
  }

  capitalize(value: string) {
    return value.substring(0, 1).toLocaleUpperCase() + value.substring(1).toLocaleLowerCase();
  }


}
